<template>
    <div class="company-detail-root">
        <Header :label="data().name" />

        <MainLayout leftToBottomRight marginTop hideOnMobile="left">
            <ProfileModule slot="left" />
            <FeaturedResource slot="left" />

            <Presentation
                slot="center"
                :description="data().description"
                :companyName="data().name"
                :isLoading="loading()"
                :isPosterLoading="isPosterLoading()"
                :poster="banner"
            />

            <Locations slot="center" :items="locations" />

            <JobModule
                key="123"
                slot="center"
                :companyName="data().name"
                :companyId="companyIds()"
                redirectUsingQuery
            />

            <CompanyModule slot="right" :id="this.$route.params.id" />

            <Paper
                slot="right"
                tall
                custom_padding="px-3 pt-4 pb-2"
                v-if="data().gptw"
            >
                <b-img
                    rounded
                    :alt="data().gptw.text"
                    :src="data().gptw.img"
                    v-b-tooltip.hover
                    :title="data().gptw.tooltip"
                    height="60"
                    class="ml-2 mb-2"
                    style="float: right"
                />
                <h4>CERTIFIED GREAT PLACE TO WORK</h4>
                <p class="mb-0">
                    Minim mollit adipisicing dolor cupidatat fugiat Lorem sunt.
                    Adipisicing anim eiusmod cillum sunt sint. Amet proident
                    aute do do veniam cupidatat magna anim qui aliqua.
                </p>
                <div class="d-flex justify-content-center">
                    <p class="mb-0 p-2 clickable" @click="toAboutGPTW">
                        Read more
                    </p>
                </div>
            </Paper>

            <Videos slot="right" :items="videos" :orgId="data().id" />

            <Articles slot="right" :items="articles" />
        </MainLayout>
    </div>
</template>

<script>
// Project components
import Header from '~/components/layouts/Header';
import MainLayout from '~/components/layouts/mainlayout/MainLayout';
import ProfileModule from '~/components/smart/ProfileModule/ProfileModule';
import CompanyModule from '~/components/smart/CompanyModule';
import FeaturedResource from '~/components/smart/FeaturedResource';

// Page specific components
import Presentation from './components/Presentation';
import Videos from './components/Videos';
import Articles from './components/Articles';
import JobModule from './components/JobModule';
import Locations from './components/Locations';

// Utils
import AnalyticService from '~/services/AnalyticService';
import UniversityService from '~/services/UniversityService';

import * as Mappers from '~/utils/mappers/mediaMappers';

export default {
    name: 'CompanyDetail',
    components: {
        Header,
        MainLayout,
        ProfileModule,
        Presentation,
        Videos,
        Articles,
        CompanyModule,
        JobModule,
        Locations,
        FeaturedResource,
    },
    data() {
        return {
            forceUpdate: true,

            hasLoggedEvent: false, // For indicating if the company-view has been logged or not
            schoolData: { loading: true },
        };
    },
    computed: {
        company() {
            const shouldUpdate = this.forceUpdate;
            this.forceUpdate = false;
            return this.$interfaces.company
                .id(this.$route.params.id)
                .get({ reactive: true, forceUpdate: shouldUpdate });
        },
        orgProfile() {
            if (this.company.loading || this.schoolData.loading) {
                return { loading: true };
            }
            let orgProfile = this.$interfaces.organization.profile
                .id(this.company.data.externalId)
                .get({ reactive: true, schoolId: this.schoolData.id });
            return orgProfile;
        },
        locations() {
            if (this.orgProfile.loading) return;
            return Mappers.mapLocations(this.orgProfile.data.locations);
        },
        videos() {
            if (this.orgProfile.loading) return;
            return Mappers.mapVideos(
                this.orgProfile.data.videos,
                this.orgProfile.data.id
            );
        },
        articles() {
            if (this.orgProfile.loading) return;
            return Mappers.mapArticles(this.orgProfile.data.articles);
        },
        organizationData() {
            return this.$interfaces.organization.profile.banner
                .id(this.$route.params.id)
                .get({
                    reactive: true,
                });
        },
        banner() {
            if (this.organizationData.loading) return;
            return this.organizationData.data.banner;
        },
        locationIds() {
            return (this.locations || []).map(it => it.id);
        },
    },
    methods: {
        data() {
            return this.company.data || {};
        },
        loading() {
            return this.company.loading;
        },
        isPosterLoading() {
            return this.organizationData.loading;
        },
        error() {
            return this.company.error;
        },
        companyIds() {
            return this.locationIds && this.locationIds.length > 0
                ? [...this.locationIds, this.data().id]
                : this.data().id;
        },
        logPageviewEvent() {
            // This triggers an Google Analytics event
            const data = this.data();
            if (data.id) {
                AnalyticService.companyViewEvent(data.id, data.name);
                this.hasLoggedEvent = true;
            }
        },
        toAboutGPTW() {
            this.$router.push(this.$URLS.aboutGPTW);
        },
    },
    mounted() {
        UniversityService.getCurrentSchoolData().then(data => {
            this.schoolData = data;
        });
        window.scrollTo(0, 0);
    },
    watch: {
        company(newCompany, oldCompany) {
            // Log company-pageview if it has not been done yet.
            // If you click onto a new company from the this page, we also have to check
            // if the company-ids have updated, so we can log again.
            if (!this.hasLoggedEvent || newCompany.ids !== oldCompany.ids) {
                this.logPageviewEvent();
            }
        },
    },
};
</script>

<style scoped>
.company-detail-root {
    padding-bottom: 100px;
}
</style>
